exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".asseco-list .mdl-list{padding:0;height:calc(100% - 26px);overflow:auto}.asseco-list ul .mdl-list__item{padding:10px;border-bottom:1px solid rgba(0,0,0,.1);letter-spacing:0}.asseco-list ul .mdl-list__item.disabled{cursor:not-allowed;pointer-events:none;opacity:.6}.asseco-list ul .mdl-list__item .mdl-list__item-secondary-content{margin-left:5px}.asseco-list ul .mdl-list__item .mdl-list__item-primary-content .mdl-list__item-icon{margin-right:15px}.asseco-list ul .mdl-list__item:hover{background-color:#f5f5f5;cursor:pointer}", ""]);

// exports
